import { createFileRoute } from '@tanstack/react-router';
import { PlusIcon } from 'lucide-react';

import { InviteMemberDialog } from '@/components/features/member/dialogs/invite-member-dialog';
import { OrganizationMemberList } from '@/components/features/member/organization-member-list';
import { RolePermissionsInfo } from '@/components/features/member/role-permissions-info';
import { useCurrentOrganization } from '@/components/features/membership/membership-provider';
import OrganizationMembersLimit from '@/components/features/organization/organization-members-limit';
import { Can } from '@/components/features/permission/can';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import {
  Page,
  PageContent,
  PageHeader,
  PageHeaderAction,
  PageHeaderDescription,
  PageHeaderInfo,
  PageHeaderTitle,
} from '@/components/ui/layout/page';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/_authenticated/member/')({
  component: UsersPage,
});

function UsersPage() {
  const { t } = useTranslation();
  const organization = useCurrentOrganization();

  return (
    <OrganizationMembersLimit organizationId={organization.organizationId}>
      {(limitExceeded) => (
        <Page>
          <PageHeader>
            <PageHeaderInfo>
              <div className="flex items-center gap-3">
                <PageHeaderTitle>
                  {t('authenticated.member.title')}
                </PageHeaderTitle>
                <OrganizationMembersLimit.Badge />
              </div>
              <PageHeaderDescription>
                {t('authenticated.member.description')}
              </PageHeaderDescription>
            </PageHeaderInfo>

            <PageHeaderAction>
              <RolePermissionsInfo />
              <Can permissions={['member:invite']}>
                {limitExceeded ? (
                  <Button disabled icon={<PlusIcon />}>
                    {t('authenticated.member.inviteMember')}
                  </Button>
                ) : (
                  <InviteMemberDialog
                    organizationId={organization.organizationId}
                    trigger={
                      <Button icon={<PlusIcon />}>
                        {t('authenticated.member.inviteMember')}
                      </Button>
                    }
                  />
                )}
              </Can>
            </PageHeaderAction>
          </PageHeader>

          <PageContent>
            <Card>
              <CardContent>
                <OrganizationMemberList />
              </CardContent>
            </Card>
          </PageContent>
        </Page>
      )}
    </OrganizationMembersLimit>
  );
}
